import { render } from "./calcoliFumo.vue?vue&type=template&id=60e6ac88&ts=true"
import script from "./calcoliFumo.vue?vue&type=script&lang=ts"
export * from "./calcoliFumo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__